module.exports = __webpack_public_path__ + "img/cli_02.c4f67ea2.png";